import { State } from "reducers";
import { selectedTile } from "selectors/gridPage";
import { Hero } from "types";

export const heroSelector = (state: State): Hero => {
  const tile = selectedTile(state);
  return tile?.hero || { mode: "none" };
};
